import OperatorService from "@/api/services/operator.service";

const BillingService = {
  get(startDate, endDate, p_id_org = "") {
    const headers = {
      start_date: startDate,
      end_date: endDate,
      id_org: p_id_org,
    };
    return OperatorService.get("/billing", { headers });
  },
  getExcel(startDate, endDate, p_id_org = "") {
    const headers = {
      start_date: startDate,
      end_date: endDate,
      id_org: p_id_org,
    };
    return OperatorService.get("/billing_excel", { headers });
  },
};

export default BillingService;
